import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioAccountsSubPage/PortfolioAccountsSubPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioEarnSubPage/PortfolioEarnSubPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistorySubPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioTradeSubPage/PortfolioTradeSubPage.tsx");
